import React, { Component, Fragment } from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import PropTypes from 'prop-types';
import styled from 'styled-components'

export const FieldWrapper = styled.div`
    margin:auto;
    width: 100%;
    display: inline-flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;;
    align-content: center;
    align-items: center;
`
export const InputTextWrapper = styled.h4`
    width: auto;
    margin: 0px;
    margin-right: 10px;
    font: 16px Open Sans, Helvetica, sans-serif;
`
export const LabelWrapper = styled.label`
    transition: 0.28s;
    overflow: hidden;
    color: red;
    margin-left: 5%;
    font-style: italic;
    -webkit-order: 0;
    -ms-flex-order: 0;
    order: 0;
    -webkit-flex: 0 1 100%;
    -ms-flex: 0 1 100%;
    flex: 0 1 100%;
    -webkit-align-self: auto;
    -ms-flex-item-align: auto;
    align-self: auto;

`
//TODO move away from material-ui
const FormSelectField = ({
    label,
    name,
    options,
    multiple,
    onChange,
    displayKey,
    valueKey,
    onfocusout,
    errorMessage,
    value,
    required
}) => {
        return (
            <FieldWrapper>
                <InputTextWrapper test-label="label">{label}</InputTextWrapper>
                <Select
                    onChange={onChange}
                    multiple={multiple}
                    name={name}
                    value={value}
                    required={required}
                    native={true}
                    inputProps={{
                        required:{required}
                    }}
                >
                    {options.map( optionItem => {
                        return(
                            <option
                                value={valueKey ? optionItem[valueKey] : optionItem}
                            >
                                {displayKey ? optionItem[displayKey] : optionItem}
                            </option>
                        );
                    })}
                </Select>
            </FieldWrapper>
        )
}

FormSelectField.propTypes = {
    /** Label to be displayed as the title */
    label: PropTypes.string.isRequired,
    /** Name of the field passed in, needed for react state changes */
    name: PropTypes.string.isRequired,
    /** Value of the field */
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array
    ]),
    /** Options to be selected */
    options: PropTypes.array.isRequired,
    /** Allows the user to select multiple options */
    multiple: PropTypes.bool,
    /** Key of the object passed in to be displayed to represent the option */
    displayKey: PropTypes.string,
    /** Key of the object that holds the value of the option selected */
    valueKey: PropTypes.string,
    /** onBlur function used for validation  */
    onfocusout: PropTypes.func,
    /** onChange function to update the value */
    onChange: PropTypes.func,
    /** String that shows if there is an error with the input validation */
    errorMessage: PropTypes.string,
};


FormSelectField.defaultProps = {
    label: 'Placeholder label',
    name: 'placeholder',
    value: '',
    options: [],
    multiple: false,
    displayKey: null,
    valueKey: null,
    onfocusout: () => null,
    onChange: () => null,
    errorMessage: null
};


export default FormSelectField;


// WEBPACK FOOTER //
// ./src/js/containers/CompanyContainer/Forms/Components/FormSelectField.js